import React from 'react'

const ArrowRightBig = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.21094 0.914071C2.86406 0.70079 2.42813 0.693759 2.07422 0.892978C1.72031 1.0922 1.5 1.4672 1.5 1.87501V10.125C1.5 10.5328 1.72031 10.9078 2.07422 11.107C2.42813 11.3063 2.86406 11.2969 3.21094 11.0859L9.96094 6.96095C10.2961 6.75704 10.5 6.39376 10.5 6.00001C10.5 5.60626 10.2961 5.24532 9.96094 5.03907L3.21094 0.914071Z" fill="currentColor"/>
  </svg>
)
export default ArrowRightBig;
